import SearchResult from './renderers/SearchResult';
import Config from 'config';
import scrollMonitor from 'scrollmonitor';
import { Actions, Store, Flummox } from 'flummox';
import SectionActions from './flux/SectionActions.js';
import SectionStore from './flux/SectionStore.js';

export default class Search {

    constructor() {
        this.searchContainerElement = null;
        this.flux = null;
        this.paginateMore = null;

        this.pageTitleElement = document.getElementsByTagName('title')[0];
        this.currentPageTitle = this.pageTitleElement ? this.pageTitleElement.text : null;

        this.searchLinkElement = document.getElementsByClassName('header_search_link')[0];
        this.searchFormContainerElement = document.getElementsByClassName('header_form_container')[0];
        this.navigationElement = document.getElementsByTagName('nav')[0];
        this.submitFormButtonElement = document.getElementsByClassName('submit_search_form')[0];
        this.resetFormButtonElement = document.getElementsByClassName('reset_search_form')[0];
        this.pageContainerElement = document.getElementById('container');
        this.searchFormElement = document.getElementById('search-form');

        this.showSearchForm();
        this.submitSearchForm();
        this.resetSearchForm();
    }

    showSearchForm() {
        this.searchLinkElement.onclick = function () {
            this.navigationElement.style.display = 'none';
            this.searchFormContainerElement.style.display = 'block';
            return false;
        }.bind(this);
    }

    submitSearchForm() {
        this.submitFormButtonElement.onclick = function () {
            this.processSubmit();
            return false;
        }.bind(this);

        this.searchFormElement.onsubmit = function () {
            this.processSubmit();
            return false;
        }.bind(this);
    }

    processSubmit() {
        this.searchData = [];
        if (this.pageTitleElement) {
            this.pageTitleElement.text = "Search results";
        }

        this.pageContainerElement.style.display = 'none';

        if (this.searchContainerElement === null) {
            this.searchContainerElement = document.createElement('div');
            this.searchContainerElement.id = 'search-container';
            this.searchContainerElement.className = 'cf';
            this.searchContainerElement.style.clear = 'both';
            this.pageContainerElement.parentNode.insertBefore(this.searchContainerElement, this.pageContainerElement.nextSibling);
        }

        let search = this.searchFormElement.getElementsByTagName('input')[0].value;
        let data = {
            search,
            page: 0,
            limit: 15,
            files: [
                {
                    file: 'data/blog.json',
                    sectionType: 'blog',
                    key: 'posts',
                    searchFields: ['title', 'content']
                },
                {
                    file: 'data/resources.json',
                    sectionType: 'blog',
                    key: 'posts',
                    searchFields: ['title', 'content']
                },
                {
                    file: 'data/faqs.json',
                    sectionType: 'faqs',
                    key: 'faqs',
                    searchFields: ['question', 'answer']
                },
            ]
        };

        this.paginateMore = false;
        this.loadData(data, (results) => {
            let footerEl = document.getElementsByClassName("footer")[0];
            this.elementWatcher = scrollMonitor.create( footerEl );
            let inProgress = false;
            this.elementWatcher.enterViewport(function() {
                if (!inProgress && this.paginateMore) {
                    data.page++;
                    inProgress = true;
                    this.loadData(data, () => {
                        inProgress = false;
                    });
                }
            }.bind(this));
        });
    }

    loadData(requestData, callback) {

        let request = new XMLHttpRequest();

        request.onreadystatechange = function() {
            if (request.readyState == 4 && request.status == 200) {
                let searchResults = JSON.parse(request.response);
                if (searchResults.length < 15) {
                    this.paginateMore = false;
                } else {
                    this.paginateMore = true;
                }
                this.runRenderer(searchResults);
                if (typeof callback === 'function') {
                    callback(searchResults);
                }
            }
        }.bind(this);

        request.open("POST", Config.BACKEND_URL + '/siteSearch?t=' + Math.floor(Date.now() / 1000));
        request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        request.send(JSON.stringify(requestData));
    }

    runRenderer(data) {
        this.searchData = this.searchData.concat(data);
        if (!this.searchResultRenderer) {
            this.searchResultRenderer = new SearchResult({parentElement: this.searchContainerElement, data: this.searchData});
        } else {
            this.searchResultRenderer.reRender(this.searchData);
        }
    }

    resetSearchForm() {
        this.resetFormButtonElement.onclick = function () {
            this.navigationElement.style.display = 'block';
            this.searchFormContainerElement.style.display = 'none';
            this.pageContainerElement.style.display = 'block';
            this.searchFormElement.getElementsByTagName('input')[0].value = "";
            if (this.searchContainerElement !== null) {
                this.searchContainerElement.parentNode.removeChild(this.searchContainerElement);
                this.searchContainerElement = null;
            }

            if (this.elementWatcher) {
                this.elementWatcher.destroy();
            }
            this.searchResultRenderer = null;
            if (this.pageTitleElement) {
                this.pageTitleElement.text = this.currentPageTitle;
            }
            return false;
        }.bind(this);
    }

}



// WEBPACK FOOTER //
// ./src/Search.js